import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { LegalLayout, P } from "./LegalLayout";
import { GREEN } from "./foundConfig";

const CARDS = [
  { to: "/found/privacy", title: "Privacy Policy", desc: "What information FOUND collects, why, and your rights." },
  { to: "/found/terms", title: "Terms of Service", desc: "The rules for using FOUND as an Artist or a Scout." },
  { to: "/found/community-guidelines", title: "Community Guidelines", desc: "What belongs on FOUND and how content is moderated." },
  { to: "/found/copyright", title: "Copyright & IP", desc: "Ownership rules and how to report infringement." },
  { to: "/found/delete-account", title: "Delete My Account", desc: "How to request deletion of your FOUND account and data." },
  { to: "/found/support", title: "Support", desc: "Get help with your account, uploads, Scouting and more." },
];

export default function LegalHub() {
  return (
    <LegalLayout
      title="FOUND — Legal & Support"
      description="Legal, privacy, safety and support resources for FOUND, the music discovery app by Dream Big Entertainment Ltd."
    >
      <P>
        Welcome to the FOUND legal and support hub. FOUND is a music discovery social
        platform where Artists share original music and fans become Scouts who discover
        emerging talent early. Use the resources below to understand how FOUND works, your
        rights, and how to get help.
      </P>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-10">
        {CARDS.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            data-testid={`hub-card-${c.to.split("/").pop()}`}
            className="group block border border-stone-800 bg-black/40 p-6 hover:border-[color:var(--g)] transition-colors"
            style={{ "--g": GREEN }}
          >
            <div className="flex items-start justify-between gap-3">
              <h2 className="font-syne font-bold text-white text-xl tracking-tight">{c.title}</h2>
              <ArrowUpRight
                size={20}
                className="text-stone-600 group-hover:text-white transition-colors shrink-0"
              />
            </div>
            <p className="font-manrope text-sm text-stone-400 mt-2 leading-relaxed">{c.desc}</p>
          </Link>
        ))}
      </div>
    </LegalLayout>
  );
}
